import { clsx } from 'clsx'

interface Props {
	className?: string
}

const HorizontalDivider = ({ className }: Props) => (
	<div class={clsx('h-px w-full bg-brightBackground', className)} />
)

export { HorizontalDivider }
